import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initCause1uc19zhi9fkfi as initCause } from './internal/StackTraceRecovery.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from './Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine } from './internal/Scopes.mjs';
import {
  get_delaynv5kl66dta33 as get_delay,
  DelayWithTimeoutDiagnostics19ibxwhhgbjz0 as DelayWithTimeoutDiagnostics,
} from './Delay.mjs';
import { Key_instancep4kcxau6t0nv as Key_instance } from './CoroutineName.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { disposeOnCompletion1zvxmj809ax5i as disposeOnCompletion } from './Job.mjs';
import { startUndispatchedOrReturnIgnoreTimeout3dcuyudwff859 as startUndispatchedOrReturnIgnoreTimeout } from './intrinsics/Undispatched.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1n9qg6fb0b5i8 as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substring3saq8ornu0luv as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *withTimeoutOrNull(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    return null;
  var coroutine = {_v: null};
  try {
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var timeoutCoroutine = new (TimeoutCoroutine())(timeMillis, uCont);
      coroutine._v = timeoutCoroutine;
      return setupTimeout(timeoutCoroutine, block);
    };
  } catch ($p) {
    if ($p instanceof TimeoutCancellationException()) {
      var e = $p;
      if (e.l18_1 === coroutine._v) {
        return null;
      }
      throw e;
    } else {
      throw $p;
    }
  }
}
var TimeoutCancellationExceptionClass;
function TimeoutCancellationException() {
  if (TimeoutCancellationExceptionClass === VOID) {
    class $ extends CancellationException() {
      constructor(message, coroutine) {
        return new.target.n18(message, coroutine);
      }
      static n18(message, coroutine) {
        var $this = this.n(message);
        captureStack($this, $this.m18_1);
        $this.l18_1 = coroutine;
        return $this;
      }
      static o18(message) {
        return this.n18(message, null);
      }
      g14() {
        var tmp0_elvis_lhs = this.message;
        // Inline function 'kotlin.also' call
        var this_0 = TimeoutCancellationException().n18(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.l18_1);
        initCause(this_0, this);
        return this_0;
      }
    }
    initMetadataForClass($, 'TimeoutCancellationException', VOID, VOID, [CopyableThrowable()]);
    TimeoutCancellationExceptionClass = $;
  }
  return TimeoutCancellationExceptionClass;
}
var TimeoutCoroutineClass;
function TimeoutCoroutine() {
  if (TimeoutCoroutineClass === VOID) {
    class $ extends ScopeCoroutine() {
      constructor(time, uCont) {
        super(uCont.qc(), uCont);
        this.t18_1 = time;
      }
      p12() {
        var delay = get_delay(this.vw_1);
        var tmp0_safe_receiver = this.vw_1.cd(Key_instance);
        var name = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a14_1;
        this.ly(TimeoutCancellationException_0(this.t18_1, delay, this, name));
      }
      jx() {
        return super.jx() + '(timeMillis=' + this.t18_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'TimeoutCoroutine', VOID, VOID, [Runnable()], [0]);
    TimeoutCoroutineClass = $;
  }
  return TimeoutCoroutineClass;
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.yz_1;
  var context = cont.qc();
  disposeOnCompletion(coroutine, get_delay(context).i14(coroutine.t18_1, coroutine, coroutine.vw_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine, coroutineName) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics()) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.j14(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var baseMessage = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  var tmp_0;
  if (!(coroutineName == null)) {
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(baseMessage) > 0) {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(baseMessage, 0);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$5 = toString(this_0).toLowerCase();
      var tmp0 = charCodeAt(tmp$ret$5, 0);
      // Inline function 'kotlin.text.plus' call
      var other = substring(baseMessage, 1);
      tmp_1 = toString(tmp0) + other;
    } else {
      tmp_1 = baseMessage;
    }
    tmp_0 = 'Coroutine "' + coroutineName + '" ' + tmp_1;
  } else {
    tmp_0 = baseMessage;
  }
  var message = tmp_0;
  return TimeoutCancellationException().n18(message, coroutine);
}
function *withTimeout(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    throw TimeoutCancellationException().o18('Timed out immediately');
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    return setupTimeout(new (TimeoutCoroutine())(timeMillis, uCont), block);
  };
}
//region block: exports
export {
  withTimeoutOrNull as withTimeoutOrNull2oszfz61ga8oq,
  withTimeout as withTimeout34v8nimvh0fh5,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
};
//endregion

//# sourceMappingURL=Timeout.mjs.map
